<button type="button" nz-button nzType="text" nzShape="circle" (click)="show()" nzSize="large"
  [nz-tooltip]="isEmptyId ? 'Account Journal' : null" [disabled]="isEmptyId">
  <span nz-icon nzType="file-search" nzTheme="outline"></span>
</button>
<nz-modal [(nzVisible)]="visible" [nzTitle]="journalTitle" (nzOnCancel)="hide()" nzWidth="1200">
  <ng-template #journalTitle>
    <span>Account Journal</span>
    @switch (documentStatus) {
    @case (0) {
    <nz-tag [nzColor]="'#FA9D94'">Draft</nz-tag>
    }
    @case (1) {
    <nz-tag [nzColor]="'#f7e9a9'">Waiting for Approval</nz-tag>
    }
    }
  </ng-template>
  <ng-container *nzModalContent>
    <app-scrollable width="300px">
      <st #st [data]="list" [columns]="columns" [body]="bodyTpl" [page]="{ show: false }" bordered="true" responsive="false"
        class="gl-background">
        <ng-template st-row="amountTitleTpl" type="title" let-c>
          <div class="text-right">{{ c.title.text }}</div>
        </ng-template>
        
        <!-- <ng-template st-row="amountTpl" let-item let-column="column">
          <div class="text-right" *ngIf="item[column.index]" nz-popover [nzPopoverTitle]="undefined"
            [nzPopoverContent]="debitPopover">{{ item[column.index] | price }}</div>

          <ng-template #debitPopover>
            <sv-container col="1" class="width-md">
              <sv [label]="column.index==='debitLocal'?'Debit':'Credit'">
                {{column.index==='debitLocal'?column.debit:column.credit|price}}
              </sv>
              <sv [label]="column.index==='debitLocal'?'Debit Local':'Credit Local'">
                {{column.index==='debitLocal'?column.debitLocal:column.creditLocal|price}}
              </sv>
            </sv-container>
          </ng-template>
        </ng-template> -->

        <ng-template st-row="debitTpl" let-item>
          <div class="text-right" *ngIf="item.debitLocal" nz-popover [nzPopoverTitle]="undefined"
            [nzPopoverContent]="debitPopover">
            {{ item.debitLocal | price }}
          </div>
          <ng-template #debitPopover>
            {{item.debit|currency:item.currency?.sign}}
          </ng-template>
        </ng-template>

        <ng-template st-row="creditTpl" let-item>
          <div class="text-right" *ngIf="item.creditLocal" nz-popover [nzPopoverTitle]="undefined"
            [nzPopoverContent]="creditPopover">
            {{ item.creditLocal | price }}
          </div>
          <ng-template #creditPopover>
            {{item.credit|currency:item.currency?.sign}}
          </ng-template>
        </ng-template>

        <ng-template #bodyTpl let-s>
          <ng-container *ngIf="st.count > 0">
            <tr class="bg-grey-lighter">
              <td colspan="5"></td>
              <td>
                <strong>TOTAL</strong>
              </td>
              <td class="text-right">
                <strong>{{ s.dr.value | price }}</strong>
              </td>
              <td class="text-right">
                <strong>{{ s.cr.value | price }}</strong>
              </td>
            </tr>
          </ng-container>
        </ng-template>
      </st>
    </app-scrollable>
  </ng-container>

  <ng-container *nzModalFooter>
    <button type="button" nz-button nzType="primary" (click)="hide()">Close</button>
  </ng-container>
</nz-modal>
